const pixelsMap = [
  // [one-level lower height value than the current resolution, current resolution]
  // Spatial dimensions must be in decreasing order, such as the one presented below:
  { area: 921600, resolution: 'FHD' }, // 1280 * 720 = 921600
  { area: 518400, resolution: 'HD' }, // 960 * 540 = 518400
  { area: 307200, resolution: 'qHD' }, // 640 * 480 = 307200
  { area: 0, resolution: 'VGA' },
];

/**
 * getSpatialResolution
 *
 * @param {width} video width number of pixels
 * @param {height} video height number of pixels
 * @returns {String | undefined} the video resolution with the format '{width}x{height}'
 */
const getSpatialResolution = (width, height) => {
  if (width < 0 || height < 0) return undefined;

  const { resolution } = pixelsMap.find(({ area }) => width * height > area) ?? {};
  return resolution;
};

export default getSpatialResolution;
